import { render } from "./ProjectPageAbout.vue?vue&type=template&id=0de52118"
import script from "./ProjectPageAbout.vue?vue&type=script&lang=js"
export * from "./ProjectPageAbout.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/Website/Website/front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__